// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2255":"3b1e880a","3918":"51b0d8d4","3998":"c5875f8a","4621":"51b0d8d4","5081":"51b0d8d4","7712":"638f7377","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};